"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const htc_1 = require("./htc");
const huawei_1 = require("./huawei");
const nokia_1 = require("./nokia");
const oppo_1 = require("./oppo");
const samsung_1 = require("./samsung");
const sony_1 = require("./sony");
const vsmart_1 = require("./vsmart");
const wiko_1 = require("./wiko");
const xiaomi_1 = require("./xiaomi");
const versionToValue = n => {
    var t = n.replace(';', '').split('.');
    return t.length >= 2
        ? parseInt(t[0].trim() + t[1].trim()) || 0
        : t.length >= 1
            ? parseInt(t[0].trim() + '0') || 0
            : null;
};
exports.ANDROI_DEVICE = htc_1.HTC.concat(huawei_1.HUAWEI)
    .concat(nokia_1.NOKIA)
    .concat(oppo_1.OPPO)
    .concat(samsung_1.SAMSUNG)
    .concat(sony_1.SONY)
    .concat(vsmart_1.VSMART)
    .concat(wiko_1.WIKO)
    .concat(xiaomi_1.XIAOMI);
exports.detectDeviceInfo = () => {
    var n = {
        deviceName: null,
        brandName: null,
        deviceCode: null,
        os: null,
        osValue: null,
        language: null
    }, r, u, t, i;
    try {
        if (((r = navigator.userAgent),
            (n.language = navigator.language),
            (u = r.substring(r.indexOf('(') + 1, r.indexOf(')'))),
            r.match(/Windows NT/i))) {
            for (n.deviceName = 'Windows',
                n.os = 'Windows NT',
                n.brandName = 'Microsoft',
                n.deviceCode = 'PC',
                i = u.split(' '),
                t = 0; t < i.length; t++)
                if (i[t].trim() == 'NT') {
                    n.osValue = versionToValue(i[t + 1].replace(/\_/g, '.'));
                    break;
                }
            return n;
        }
        if (r.match(/Android/i)) {
            for (n.deviceName = u.split(';')[2].trim(), i = u.split(' '), t = 0; t < i.length; t++)
                if (i[t].trim() == 'Android') {
                    n.os = 'Android';
                    n.osValue = versionToValue(i[t + 1].replace(/\_/g, '.'));
                    break;
                }
            const androidDeviceList = exports.ANDROI_DEVICE;
            for (androidDeviceList, t = 0; t < androidDeviceList.length; t++) {
                if (r.indexOf(androidDeviceList[t].deviceCode) > -1) {
                    n.deviceName = androidDeviceList[t].deviceName;
                    n.brandName = androidDeviceList[t].brandName;
                    n.deviceCode = androidDeviceList[t].deviceCode;
                    break;
                }
            }
        }
        else
            r.match(/iPhone/i)
                ? ((n.brandName = 'Apple'),
                    (n.os = 'iOS'),
                    (screen.height == 568 && screen.width == 320) ||
                        (screen.height == 320 && screen.width == 568)
                        ? ((n.deviceName = 'iPhone 5'), (n.deviceCode = 'iPhone5'))
                        : (screen.height == 375 && screen.width == 667) || screen.height == 667
                            ? ((n.deviceName = 'iPhone 6'), (n.deviceCode = 'iPhone6'))
                            : screen.height == 414 || screen.height == 736
                                ? ((n.deviceName = 'iPhone 6Plus'), (n.deviceCode = 'iPhone6Plus'))
                                : (screen.height == 375 && screen.width == 812) || screen.height == 812
                                    ? ((n.deviceName = 'iPhone X'), (n.deviceCode = 'iPhoneX'))
                                    : ((screen.height == 414 && screen.width == 896) || screen.height == 896) &&
                                        devicePixelRatio == 2
                                        ? ((n.deviceName = 'iPhone Xr'), (n.deviceCode = 'iPhoneXr'))
                                        : (screen.height == 414 && screen.width == 896) || screen.height == 896
                                            ? ((n.deviceName = 'iPhone Xs Max'), (n.deviceCode = 'iPhoneXsMax'))
                                            : screen.height / screen.width == 1.5 && devicePixelRatio == 2
                                                ? ((n.deviceName = 'iPhone 4'), (n.deviceCode = 'iPhone4'))
                                                : ((n.deviceName = 'iPhone 3G'), (n.deviceCode = 'iPhone3G')),
                    (i = u.split(';')[1].split(' ')),
                    (n.osValue = versionToValue(i[4].replace(/\_/g, '.'))))
                : r.match(/iPad/i)
                    ? ((n.brandName = 'Apple'),
                        (n.os = 'iOS'),
                        screen.height / screen.width == 1024 / 768
                            ? devicePixelRatio == 1
                                ? ((n.deviceName = 'iPad 2'), (n.deviceCode = 'iPad2'))
                                : ((n.deviceName = 'iPad 5'), (n.deviceCode = 'iPad5'))
                            : screen.height / screen.width == 1112 / 834
                                ? ((n.deviceName = 'iPad Pro 10.5'), (n.deviceCode = 'iPadPro10.5'))
                                : screen.height / screen.width == 1366 / 1024 &&
                                    ((n.deviceName = 'iPad Pro 12.9'), (n.deviceCode = 'iPadPro12.9')),
                        (i = u.split(';')[1].split(' ')),
                        (n.osValue = versionToValue(i[3].replace(/\_/g, '.'))))
                    : ((n.deviceName = u.split(';')[0].trim()), (n.os = u.split(';')[1].trim()));
    }
    catch (f) {
        console.log(f);
    }
    return n;
};
//# sourceMappingURL=index.js.map